import React from 'react';
const DiskTab = () => React.createElement("span", { className: "sirius-icon sirius-icon-disk" });
DiskTab.Enhance = () => React.createElement("span", { className: "sirius-icon sirius-icon-disk sirius-icon-disk-enhance" });
export default DiskTab;
